import { render, staticRenderFns } from "./Bye.vue?vue&type=template&id=cc22a322&scoped=true"
import script from "./Bye.vue?vue&type=script&lang=js"
export * from "./Bye.vue?vue&type=script&lang=js"
import style0 from "./Bye.vue?vue&type=style&index=0&id=cc22a322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc22a322",
  null
  
)

export default component.exports